import { createReducer, combineReducers } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import * as actions from 'store/medications/actions';
import { createFetchReducer, FetchingReducerState } from 'store/setLocalStore';
import { Medication, ShareMedications } from './types';

export type MedicationsListState = FetchingReducerState<Medication[]>;
export type MedicationDetailsState = FetchingReducerState<Medication>;

export interface ShareMedicationsState {
  isSending: boolean;
  data: ShareMedications | {};
}

export interface MedicationsDownloadsState {
  isDownloading: boolean;
  error: Nullable<Error>;
}

export interface MedicationsState {
  medications: MedicationsListState;
  medicationDetails: MedicationDetailsState;
  activeEncounterMedications: MedicationsListState;
  shareMedications: ShareMedicationsState;
  medicationsDownloads: MedicationsDownloadsState;
}

const medicationsReducer = createFetchReducer<Medication[]>(actions.GET_MEDICATIONS, true);

const medicationDetailsReducer = createFetchReducer<Medication>(
  actions.GET_MEDICATION_DETAILS,
  true
);

export const activeEncounterMedicationsReducer = createFetchReducer<Medication[]>(
  actions.GET_MEDICATIONS_BY_ENCOUNTER_ID,
  true
);

export const shareMedicationsInitialState = (): ShareMedicationsState => ({
  isSending: false,
  data: {}
});

export const shareMedicationsReducer = createReducer(shareMedicationsInitialState(), {
  [actions.SHARE_MEDICATIONS]: state => {
    state.isSending = true;
  },
  [actions.SHARE_MEDICATIONS_SUCCESS]: (state, action) => {
    state.isSending = false;
    state.data = action.payload.data;
  },
  [actions.SHARE_MEDICATIONS_FAIL]: state => {
    state.isSending = false;
  }
});

export const medicationsDownloadsInitialState = (): MedicationsDownloadsState => ({
  isDownloading: false,
  error: null
});

const medicationsDownloadsReducer = createReducer(medicationsDownloadsInitialState(), {
  [actions.DOWNLOAD_MEDICATIONS]: state => {
    state.isDownloading = true;
    state.error = null;
  },
  [actions.DOWNLOAD_MEDICATIONS_SUCCESS]: state => {
    state.isDownloading = false;
  },
  [actions.DOWNLOAD_MEDICATIONS_FAIL]: (state, action) => {
    state.isDownloading = false;
    state.error = action.error;
  }
});

export default combineReducers({
  medications: medicationsReducer,
  medicationDetails: medicationDetailsReducer,
  activeEncounterMedications: activeEncounterMedicationsReducer,
  shareMedications: shareMedicationsReducer,
  medicationsDownloads: medicationsDownloadsReducer
});
